var render = function render(){var _vm=this,_c=_vm._self._c;return _c('font-awesome-icon',{attrs:{"icon":_vm.state.order[_vm.field] && _vm.state.order[_vm.field] == 'asc'
      ? 'chevron-up'
      : 'chevron-down'}})
}
var staticRenderFns = []

export { render, staticRenderFns }